import { render, staticRenderFns } from "./context-menu.vue?vue&type=template&id=05a99839&scoped=true&"
import script from "./context-menu.vue?vue&type=script&lang=ts&"
export * from "./context-menu.vue?vue&type=script&lang=ts&"
import style0 from "./context-menu.vue?vue&type=style&index=0&id=05a99839&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a99839",
  null
  
)

export default component.exports